import { useEffect, useState } from "react";

export const LG_MEDIA_QUERY = "(min-width: 1024px)";

export function useIsLg() {
  const [isLg, setIsLg] = useState(
    () =>
      typeof window !== "undefined" &&
      typeof window.matchMedia === "function" &&
      window.matchMedia(LG_MEDIA_QUERY).matches
  );

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function")
      return undefined;
    const mq = window.matchMedia(LG_MEDIA_QUERY);
    const onChange = () => setIsLg(mq.matches);
    onChange();
    if (typeof mq.addEventListener === "function") {
      mq.addEventListener("change", onChange);
      return () => mq.removeEventListener("change", onChange);
    }
    mq.addListener(onChange);
    return () => mq.removeListener(onChange);
  }, []);

  return isLg;
}
